import { TextAreaField } from 'modules/templateEditor/common/components';
import { TextAreaFieldProps } from 'modules/templateEditor/common/types';
import { HandlebarsMessage } from 'modules/templateEditor/common/HandlebarsMessage';
import { hasHandlebars } from 'modules/templateEditor/common/utils';
import { useTranslations } from 'modules/templateEditor/hooks/useTranslations';
import { FormField } from 'ui/formField';

type TextAreaFormFieldProps = TextAreaFieldProps & {
  labelText: string;
  isEditModeVisible: boolean;
  errorText?: string | JSX.Element;
  warningText?: string | JSX.Element;
  hasError: boolean;
  hasWarning: boolean;
};

type CharCountProps = {
  textContent?: string;
};

const CharCount = ({ textContent = '' }: CharCountProps) => {
  const { t } = useTranslations();
  return hasHandlebars(textContent) ? (
    <HandlebarsMessage />
  ) : (
    <div data-test="char-count-text">
      {t('dynamic.characterLength', { count: textContent?.length })}
    </div>
  );
};

export const TextArea = ({
  labelText,
  hasError,
  errorText,
  hasWarning,
  warningText,
  placeholderText,
  mediumRef,
  mediumDataKey,
  mediumDataValue,
  isEditModeVisible,
  onChangeHandler,
}: TextAreaFormFieldProps) => {
  return (
    <FormField
      data-testid={`${mediumDataKey}-field`}
      isHorizontalLayout
      labelText={labelText}
      restrictionText={isEditModeVisible && <CharCount textContent={mediumDataValue} />}
      hasError={hasError}
      hasWarning={hasWarning}
      errorText={errorText}
      warningText={warningText}
    >
      <TextAreaField
        mediumRef={mediumRef}
        mediumDataKey={mediumDataKey}
        mediumDataValue={mediumDataValue}
        onChangeHandler={onChangeHandler}
        placeholderText={placeholderText}
        hasError={hasError}
      />
    </FormField>
  );
};
